import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const titleStyles = css`
  align-items: center;
  color: ${etiColors.black};
  display: flex;
  font-size: 1.25rem;
`;
const indicatorStyles = active => css`
  align-items: center;
  background-color: ${etiColors.grayScale[active ? 10 : 4]};
  border-radius: 50%;
  color: ${active ? etiColors.white : etiColors.black};
  display: flex;
  font-size: 1rem;
  height: 24px;
  justify-content: center;
  margin-right: 10px;
  width: 24px;

  [dir='rtl'] & {
    margin-left: 10px;
    margin-right: 0;
  }
`;
const ManulifeStepTitle = _ref => {
  let {
    isActive,
    step,
    text
  } = _ref;
  return /*#__PURE__*/_jsxs("h2", {
    className: titleStyles,
    children: [/*#__PURE__*/_jsx("span", {
      className: indicatorStyles(isActive),
      children: step
    }), text]
  });
};
ManulifeStepTitle.propTypes = {
  isActive: PropTypes.bool,
  step: PropTypes.string,
  text: PropTypes.string
};
export default ManulifeStepTitle;
//# sourceMappingURL=ManulifeStepTitle.js.map